import { Box, Typography, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Container maxWidth="sm">
      <Box display="flex" flexDirection="column" alignItems="center" sx={{ mt: { xs: 4, sm: 8 } }}>
        <Typography variant="h3" gutterBottom>{t('notFound.title')}</Typography>
        <Typography variant="body1" color="text.secondary">
          {t('notFound.message')}
        </Typography>
      </Box>
    </Container>
  );
}
